module.exports = global["jQuery"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/expose-loader?jQuery!/home/dani/kaiwa/~/jquery/dist/jquery.js
// module id = 297
// module chunks = 1